/**
 * Order Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface O2oCancelResultVO { 
    result?: O2oCancelResultVO.ResultEnum;
}
export namespace O2oCancelResultVO {
    export const ResultEnum = {
        Cancelled: 'CANCELLED',
        EscalatedManualIntervention: 'ESCALATED_MANUAL_INTERVENTION'
    } as const;
    export type ResultEnum = typeof ResultEnum[keyof typeof ResultEnum];
}


